import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import GoPro from "./customerFacing/gopro/go-pro-page.jsx";
import Products from "./customerFacing/products/prodpage.jsx";
import Purchase from "./customerFacing/products/purchase/page.jsx";
import Orders from "./customerFacing/orders/order-page.jsx";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'; // Import useLocation

const ScrollToTop = () => {
  const location = useLocation(); // This hook provides access to the current location object

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top with smooth behavior
  }, [location]); // This will run every time the location changes

  return null; // No need to render anything
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop /> {/* Scroll to top logic here */}
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/products' element={<Products />} />
        <Route path='/orders' element={<Orders />} />
        <Route path='/go-pro' element={<GoPro />} />
        <Route path='/products/purchase/:productId' element={<Purchase />} /> {/* Corrected dynamic path */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);